module.exports = __webpack_public_path__ + "static/media/money.eab04acc.png";